import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

interface UseE55RejectOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

/**
 * Hook for rejecting E55 files with an optional comment
 * @param options Configuration options for the mutation
 * @returns Mutation object for rejecting files
 */
export function useE55Reject(options: UseE55RejectOptions = {}) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ fileId, comment }: { fileId: number; comment?: string }) => {
      const params: Record<string, string> = {};
      
      // Only add comment parameter if provided and not empty
      if (comment && comment.trim() !== '') {
        params.comment = comment.trim();
      }
      
      const response = await axios.delete(`/data-set/e55/${fileId}`, {
        params
      });
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate related queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['e55'] });
      queryClient.invalidateQueries({ queryKey: ['e55-inbound'] });
      queryClient.invalidateQueries({ queryKey: ['e55-outbound'] });
      
      // Call the onSuccess callback if provided
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      // Call the onError callback if provided
      if (options.onError) {
        options.onError(error);
      }
    }
  });
} 